import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import {
  Container, Row, Col, Card, CardBody, Button, Spinner, Badge, Table
} from "reactstrap";
import { Eye, EyeOff, AlertTriangle } from 'react-feather';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import { Fn_FillListData, Fn_GetReport } from "store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";

// Define ledger data
const ledgers = [
  { id: 8, name: 'Company Bank', unit: '₹', color: 'success' },
  { id: 40, name: 'Company Coin', unit: ' Coins', isSuffix: true, color: 'warning' },
  { id: 3, name: 'Company Digital Gold', unit: ' g', isSuffix: true, color: 'info' },
  { id: 34, name: 'Company Digital Silver', unit: ' g', isSuffix: true, color: 'secondary' },
];

const Dashboard = props => {
  //meta title
  document.title = "Dashboard | Skote - React Admin & Dashboard Template";

  // Initialize visibility state for each ledger
  const initialVisibility = ledgers.reduce((acc, ledger) => {
    acc[ledger.id] = false;
    return acc;
  }, {});

  const [state, setState] = useState({
    id: 0,
    ledgerBalances: {},
    FillArray2: [],
    FillArray3: [],
    PeriodArray: [],
    TableArr: [],
    formData: {
      IsGst: false,
      IsTds: false,
      selectedMemberId: "",
      selectedLedgerId: "",
    },
    OtherDataScore: [],
    loadingLedgerId: null,
    visibility: initialVisibility,
    activeLedgerId: null,
    lowStockItems: [],
    loadingLowStock: false,
  })
  const dispatch = useDispatch();

  const API_URL_BALANCE = "GetBalanceUsers";
  const API_URL_ITEMS = `${API_WEB_URLS.MASTER}/0/token/Top5MinItemStock/Id/0`;

  // Fetch low stock items on component mount
  useEffect(() => {
    fetchLowStockItems();
  }, []);

  const fetchLowStockItems = async () => {
    setState(prev => ({ ...prev, loadingLowStock: true }));
    
    try {
      const items = await Fn_FillListData(dispatch, setState, "ItemMaster", API_URL_ITEMS);
      
      if (items && Array.isArray(items)) {
        // Filter items with TotalQty and sort by quantity (ascending)
        const itemsWithQty = items
          .filter(item => item.TotalQty !== null && item.TotalQty !== undefined)
          .sort((a, b) => parseFloat(a.TotalQty) - parseFloat(b.TotalQty))
          .slice(0, 5); // Get top 5 items with minimum quantity
        
        setState(prev => ({ 
          ...prev, 
          lowStockItems: itemsWithQty,
          loadingLowStock: false 
        }));
      }
    } catch (error) {
      console.error("Error fetching low stock items:", error);
      setState(prev => ({ 
        ...prev, 
        lowStockItems: [],
        loadingLowStock: false 
      }));
    }
  };

  const handleGetData = async (Id) => {
    setState(prev => ({ ...prev, loadingLedgerId: Id }));

    const vformData1 = new FormData()
    vformData1.append('id', Id);
    try {
      const res = await Fn_GetReport(
        dispatch,
        setState,
        "FillArray",
        `${API_URL_BALANCE}/${Id}/token`,
        { arguList: { id: Id, formData: vformData1 } },
        true
      );
      
      if (res && Array.isArray(res) && res.length > 0 && res[0].hasOwnProperty('Balance')) {
        const balance = res[0].Balance;
        setState(prev => ({
          ...prev,
          ledgerBalances: {
            ...prev.ledgerBalances,
            [Id]: balance
          },
          loadingLedgerId: null,
          activeLedgerId: Id
        }));
      } else {
         console.warn(`Unexpected response format for ledger ID ${Id}:`, res);
         setState(prev => ({ 
             ...prev, 
             ledgerBalances: { ...prev.ledgerBalances, [Id]: 'Error' },
             loadingLedgerId: null 
         }));
      }
    } catch (error) {
       console.error(`Error fetching balance for ledger ID ${Id}:`, error);
       setState(prev => ({ 
           ...prev, 
           ledgerBalances: { ...prev.ledgerBalances, [Id]: 'Error' },
           loadingLedgerId: null 
       }));
    }
  }

  const toggleVisibility = (id) => {
    const isCurrentlyVisible = state.visibility[id];
    const newVisibility = !isCurrentlyVisible;

    setState(prev => ({
      ...prev,
      visibility: {
        ...prev.visibility,
        [id]: newVisibility,
      }
    }));

    if (newVisibility) {
      if (state.ledgerBalances[id] === undefined) {
         handleGetData(id);
      } else {
         setState(prev => ({ ...prev, activeLedgerId: id }));
      }
    } else {
      if (state.activeLedgerId === id) {
        setState(prev => ({ ...prev, activeLedgerId: null }));
      }
    }
  };

  const formatBalance = (balance, unit = '', isSuffix = false, ledgerName = '') => {
    if (balance === 'Error') {
        // Display error state more clearly
        return <Badge color="danger" pill>Error</Badge>;
    }
    if (balance === null || balance === undefined) {
        // More subtle 'Not Available'
        return <span className="text-muted fst-italic">N/A</span>;
    }

    let formattedValue = '';
    if (typeof balance === 'number') {
        // Format number to 2 decimal places, removing trailing .00 for whole numbers if desired
        formattedValue = balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
        formattedValue = String(balance);
    }

    // Apply unit/currency symbol
    if (isSuffix) {
        return <>{formattedValue}{unit}</>;
    } else {
        return <>{unit}{formattedValue}</>;
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          {/* Low Stock Items Table */}
          {/* <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center mb-3">
                    <AlertTriangle className="text-warning me-2" size={20} />
                    <h4 className="card-title mb-0">Items with Minimum Quantity</h4>
                  </div>
                  
                  {state.loadingLowStock ? (
                    <div className="text-center py-4">
                      <Spinner color="primary" />
                      <p className="mt-2 text-muted">Loading low stock items...</p>
                    </div>
                  ) : state.lowStockItems.length > 0 ? (
                    <div className="table-responsive">
                      <Table className="table table-striped table-bordered">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Warehouse</th>
                            <th>Item Group</th>
                            <th>Item Code</th>
                            <th>Item Name</th>
                            <th>Current Quantity</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {state.lowStockItems.map((item, index) => (
                            <tr key={item.Id}>
                              <td>{index + 1}</td>
                              <td>{item.WarehouseName || 'N/A'}</td>
                              <td>{item.ItemGroupName || 'N/A'}</td>
                              <td>
                                <span className="fw-medium">{item.ItemCode || 'N/A'}</span>
                              </td>
                              <td>{item.ItemName || 'N/A'}</td>
                              <td>
                                <span className="fw-bold text-danger">
                                  {parseFloat(item.TotalQty || 0).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                <Badge 
                                  color={parseFloat(item.TotalQty || 0) <= 10 ? 'danger' : 'warning'} 
                                  pill
                                >
                                  {parseFloat(item.TotalQty || 0) <= 10 ? 'Critical' : 'Low Stock'}
                                </Badge>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <AlertTriangle className="text-muted mb-2" size={48} />
                      <p className="text-muted">No low stock items found</p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row> */}

        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
